import { useCoverPageContext } from "./CoverPageProvider"

/** Keep known resource data usable during background refetches. */
export function useCoverPageHasLoadedResource() {
  return useCoverPageContext(
    ({ resource, resourceId }) => !!resource && resource.id === resourceId
  )
}
